import React from 'react';


export default function ShareIcon() {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.3336 5.3335V10.6668C8.56692 12.0375 5.30692 19.7175 4.00025 26.6668C3.95092 26.9415 11.1789 18.7175 17.3336 18.6668V24.0002L28.0003 14.6668L17.3336 5.3335Z" stroke="#071013" strokeOpacity="0.5" strokeLinecap="round"/>
</svg>

  )
}
